module.exports = __webpack_public_path__ + "static/media/caixa.522973d1.svg";